<ul class="svglist">
  <li *ngFor="let svg of svglist; let i = index"
      class="svglist__svg">
    <label *ngIf="svg.label">{{svg.label}}</label>
    <button class="svglist__svg__button"
            type="button"
            [ngClass]="{'svglist__svg__button--active': (!value && i ===0) || (value === svg.value)}"
            (click)="setActive(svg.value)"
            [innerHTML]="getSafeSvg(svg)">
    </button>
  </li>
</ul>